class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    this.addEventListener('click', this.onFacetClick.bind(this));

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static initPopupSortBy() {
    FacetFiltersForm.addSortLinkListeners = () => {
      const sortBySelect = document.getElementById('SortBy'); // Reacquire reference
      const facetForm = document.querySelector('#FacetFiltersForm');
      const sortLinks = document.querySelectorAll('.sort-value__link');

      if (!sortBySelect || !facetForm) {
        console.error('SortBy select or Facet form not found');
        return;
      }

      sortLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();

          const sortValue = link.getAttribute('data-sort-by');
          sortBySelect.value = sortValue; // Ensure value updates
          sortBySelect.dispatchEvent(new Event('change'));

          // Trigger form submission with updated searchParams
          const searchParams = new URLSearchParams(new FormData(facetForm)).toString();
          FacetFiltersForm.renderPage(searchParams, event);
        });
      });

      const sortPopupTrigger = document.querySelector('#SortByPopup');
      const sortPopupOverlay = document.querySelector('.sort-popup-overlay');
      const sortPopupWrapper = document.querySelector('.sort-values-wrapper');

      if (sortPopupTrigger) {
        sortPopupTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (event.target.classList.contains('sort-popup-overlay') || event.target.classList.contains('sort-close')) {
            sortPopupWrapper.classList.remove('active');
            sortPopupOverlay.classList.remove('active');
          }
          if (event.target.classList.contains('sort-header')) {
            sortPopupWrapper.classList.toggle('active');
            sortPopupOverlay.classList.toggle('active');
          }
        });
      }

      const printPoppuTrigger = document.querySelector('#print_filter');
      const printPopupOverlay = document.querySelector('.print-popup-overlay');
      const printPopupWrapper = document.querySelector('.print-values-wrapper');

      if (printPoppuTrigger) {
        printPoppuTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (event.target.classList.contains('print-popup-overlay') || event.target.classList.contains('print-close')) {
            printPopupWrapper.classList.remove('active');
            printPopupOverlay.classList.remove('active');
          }
          if (event.target.classList.contains('print-header')) {
            printPopupWrapper.classList.toggle('active');
            printPopupOverlay.classList.toggle('active');
          }
        });
      }

      const printFilterRedirectTrigger = document.querySelectorAll('.print-filter-value');
      printFilterRedirectTrigger.forEach((element) => {
        let title = element.getAttribute('data-tag');
        let newTitle = title.replace(/ /g, '+');
        element.addEventListener('click', (event) => {
          event.preventDefault();

          let pageURL = window.location.href;
          pageURL = pageURL.replace('%2F', '/');

          if (pageURL.includes(`filter.p.tag=${newTitle}`)) {
            let newUrl = pageURL.replace('%2F', '/');
            newUrl = newUrl.replace(`filter.p.tag=${newTitle}`, '');
            newUrl = newUrl.replace('?&', '?');
            newUrl = newUrl.replace('&&', '&');
            newUrl = newUrl.endsWith('&') ? newUrl.slice(0, -1) : newUrl;
            newUrl = newUrl.endsWith('?') ? newUrl.slice(0, -1) : newUrl;
            FacetFiltersForm.printFilterTags.delete(newTitle);
            window.location.href = newUrl;
          } else {
            if (pageURL.includes('?')) {
              FacetFiltersForm.printFilterTags.add(newTitle);
              window.location.href = `${pageURL}&filter.p.tag=${newTitle}`;
            } else {
              FacetFiltersForm.printFilterTags.add(newTitle);
              window.location.href = `${pageURL}?filter.p.tag=${newTitle}`;
            }
          }
        });

        // Add active class if URL contains newTitle
        if (window.location.href.includes(`filter.p.tag=${newTitle}`)) {
          element.classList.add('active');
          FacetFiltersForm.printFilterTags.add(newTitle);
        }
      });
    };

    FacetFiltersForm.addSortLinkListeners(); // Initial attach
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static closeFilterPopup() {
    FacetFiltersForm.closeFilterPopupListeners = () => {
      const closeFilterPopupBtn = document.querySelectorAll('.close-filter-popup');

      closeFilterPopupBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.target.closest('details').removeAttribute('open');
        });
      });
    };
    FacetFiltersForm.closeFilterPopupListeners();
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    // Preserve print filter tags in searchParams
    let finalSearchParams = searchParams;
    if (FacetFiltersForm.printFilterTags.size > 0) {
      const printTags = Array.from(FacetFiltersForm.printFilterTags)
        .map((tag) => `filter.p.tag=${tag}`)
        .join('&');
      finalSearchParams = searchParams ? `${searchParams}&${printTags}` : printTags;
    }

    let renderPromises = sections.map((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${finalSearchParams}`;
      const filterDataUrl = (element) => element.url === url;

      return FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    Promise.all(renderPromises).then(() => {
      if (updateURLHash) FacetFiltersForm.updateURLHash(finalSearchParams);

      // Ensure event listeners are reattached after all rendering
      FacetFiltersForm.addSortLinkListeners();
      FacetFiltersForm.closeFilterPopupListeners();
    });

    event?.target.closest('details')?.removeAttribute('open');
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // Reattach event listeners after rendering
    FacetFiltersForm.addSortLinkListeners();
    FacetFiltersForm.closeFilterPopupListeners();

    const collectionView = document.querySelector('collection-view');
    if (collectionView) {
      collectionView.setActiveView();
    }

    try {
      initProductImageSlider();
    } catch (error) {
      console.log('Error initializing product media slider');
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    try {
      const searchParams = new URLSearchParams(formData);
      const keys = Array.from(formData.keys());
      const hasRelevantParams = keys.some(key => key !== 'sort_by' && key !== 'filter.v.availability');

      if (!hasRelevantParams) {
        searchParams.delete('filter.v.availability');
      } else if (!searchParams.has('filter.v.availability')) {
          searchParams.append('filter.v.availability', '1');
      }

      return searchParams.toString();
    } catch (error) {
      console.log('error', error);
      return new URLSearchParams(formData).toString();
    }
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    try {
      const searchParams = new URLSearchParams(url);
      const keys = Array.from(searchParams.keys());
      
      // Check if there are any relevant params (other than sort/availability)
      const hasRelevantParams = keys.some(key => 
        key !== 'sort_by' && key !== 'filter.v.availability'
      );

      if (!hasRelevantParams) searchParams.delete('filter.v.availability');

      FacetFiltersForm.renderPage(searchParams.toString());
    } catch (error) {
      console.log('error', error);
      FacetFiltersForm.renderPage(url);
    }
  }

  onFacetClick({ target }) {
    const targetEl = target.closest('.facets__summary, .sort-header, .print-header') || target;
    const targetClasses = ['facets__summary', 'sort-header', 'print-header'];

    // Early return if target doesn't match any of our classes
    if (!targetClasses.some(className => targetEl.classList.contains(className))) return;

    // Close other open details elements
    this.querySelectorAll('details[open]').forEach(details => {
      const summary = details.querySelector('.facets__summary');
      if (summary && summary !== targetEl) {
        details.removeAttribute('open');
      }
    });

    // Handle popup states with a more DRY approach
    const popupTypes = [
      { type: 'sort', isActive: targetEl.classList.contains('sort-header') },
      { type: 'print', isActive: targetEl.classList.contains('print-header') }
    ];

    popupTypes.forEach(({ type, isActive }) => {
      if (!isActive) {
        const overlay = document.querySelector(`.${type}-popup-overlay`);
        const wrapper = document.querySelector(`.${type}-values-wrapper`);
        
        if (overlay) overlay.classList.remove('active');
        if (wrapper) wrapper.classList.remove('active');
      }
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.printFilterTags = new Set(); // Store print filter tags
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.initPopupSortBy();
FacetFiltersForm.closeFilterPopup();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
